<template>
    <div class="GemaResult_container">
        <template v-if="hasScored || isEventsScored">
			<div class="ranking_title" :class="{'shadow': isFixed && group.scoreType == 0}" :style="{'top': rankingTitleStickyTop + 'px'}">
				<div class="group_name">
					<div @click="openSelectGroup">
						<span>{{group.name}}</span>
                        <YD-image :src="showGroup ? 'icon/icon_下拉箭头_黑色_向上' : 'icon/icon_下拉箭头_黑色_向下'"></YD-image>
					</div>
				</div>
				<div class="ranking_title_content" :class="`type_${group.type}`">
					<ul>
						<li class="info">{{group.scoreType == 0 ? '名次':'奖项'}}/{{['运动员','队伍','组合'][group.type - 1]}}</li>
						<li class="affiliated_unit" v-if="[1,3].includes(group.type)">单位</li>
					</ul>
				</div>
			</div>
            <div class="ranking_content" :class="`type_${group.type}`" ref="ranking_content">
                <ul v-if="group.scoreType == 0">
                    <li v-for="(item,index) in groupRankingList" :key="index">
                        <div class="info">
                            <i>{{item.Ranking}}</i>
                            <span>{{item.TeamName}}</span>
                        </div>
                        <div class="affiliated_unit" v-if="[1,3].includes(group.type)">{{item.CompanyName}}</div>
                    </li>
                </ul>
                <ul v-else>
                    <template v-for="(item,index) in groupPrizeRankingList">
                        <li class="prize_title" :style="{'top': prizeSectionStickyTop + 'px'}">
							<div class="prize_title_fixed">{{item.title}}</div>
                        </li>
                        <li v-for="(subItem, index) in item.list" :key="subItem.TeamRankingId">
                            <div class="info prize">
                                <span>{{subItem.TeamName}}</span>
                            </div>
                            <div class="affiliated_unit" v-if="[1,3].includes(group.type)">{{subItem.CompanyName}}</div>
                        </li>
                    </template>
                </ul>
                <div class="load_more" v-show="loadMore">{{loadMore}}</div>
            </div>
        </template>
        <div class="column_list" v-if="channelList.length > 0" v-show="!hasScored || isGetAll">
            <ul>
                <li v-for="(item,index) in channelList" :key="index"
                    @click="item.url ? goDetail(item.url) : 'javascript:;'"
                >
                    <div class="release_info">
                        <div>
                            <YD-image src="icon/新闻公告"></YD-image>
                            <span>赛程赛果</span>
                        </div>
                        <div class="release_time">{{item.addDate | dateFormat('yyyy年M月d日发布')}}</div>
                    </div>
                    <div class="communique_content">
                        <div class="communique_title">{{item.title}}</div>
                        <YD-image src="match_detail/icon赛程赛果"></YD-image>
                    </div>
                </li>
            </ul>
        </div>
        <template v-if="!(hasScored || isEventsScored) && channelListLoadMore">
            <Text-prompt :text="channelListLoadMore" noDataImg="no_data/暂无内容@2x.png"></Text-prompt>
        </template>
		<Popup ref="groupPopup" type="bottom" :mask-click="false">
			<div class="select_group">
				<div class="group_list">
					<ul>
						<li v-for="(item,index) in groupList" :key="index"
							:class="{'active':group.id == item.Id}" @click.stop="selectGroup(item)">
							<span>{{item.Name}}</span>
						</li>
					</ul>
				</div>
				<div class="button" @click="closeSelectGroup">取消</div>
			</div>
		</Popup>
    </div>
</template>
<script>
import tools from '@/common/tools.js';
import appInteraction from '@/common/appInteraction.js';
import Popup from '../../../components/Popup.vue';
export default {
    name: 'GemaResult',
    components:{
        Popup
    },
    props:{
        subLeagueId:{
            type: Number,
            default: 0
        },
        channelUrl:{
            type: String,
            default: ''
        },
        hasScored:{
            type: Boolean,
            default: false
        },
        isFixed: {
            type: Boolean,
            default: false
        },
        isSynthesis: {
            type: Boolean,
            default: false
        },
        events: Object
    },
    data(){
        return {
            channelList: [],
            channelListLoadMore:'加载中...',
            group: {
                name: '',
                type: 1,
                id: 0,
                scoreType: 0
            }, //组别
            groupList: [],
            showGroup: false,
            lastId: 0,
            groupRankingList: [],
            isGetData: false,
            isGetAll: false,
            loadMore:'',
            isRankingShow: true,
            itemKey: '',
			isEventsScored: false
        }
    },
    created(){
        if(this.isSynthesis){
            this.getEventsNewsList();
        }
        if(this.isSynthesis){
            this.getEventsRankingList(true);
        }else if(this.hasScored){
            this.GetRankingList(1);
        }else{
            this.getNewsList();
        }
        this.scrollEnd = function(){
            if(this.isGetData){
                this.GetRankingList(2, this.lastId);
            }
        }
    },
    watch:{
        events: {
            deep: true,
            handler(){
                this.getEventsNewsList();
                this.getEventsRankingList(true);
            }
        }
    },
    computed:{
        fixedTop(){
            return tools.remToPx(422 - 88);
        },
        // ranking_title 吸附位置
        rankingTitleStickyTop() {
            return tools.remToPx(168) + (this.isSynthesis ? tools.remToPx(80) : 0);
        },
        // prize_title 吸附位置
        prizeSectionStickyTop() {
            return this.rankingTitleStickyTop + tools.remToPx(156);
        },
        groupPrizeRankingList() {
            let list = [...this.groupRankingList];

            if (this.group.scoreType == 1 && list.length > 0) {
                let groupedData = [];
                let currentGroup = [];
                for (let i = 0; i < list.length; i++) {
                    const obj = list[i];
                    const prevObj = list[i - 1];
                    if (prevObj && prevObj.Prize === obj.Prize) {
                        currentGroup.push(obj);
                    } else {
                        if (currentGroup.length > 0) {
                            groupedData.push({
                                title: currentGroup[0].Prize,
                                list: currentGroup
                            });
                        }
                        currentGroup = [obj];
                    }
                }
                if (currentGroup.length > 0) {
                    groupedData.push({
                        title: currentGroup[0].Prize,
                        list: currentGroup
                    });
                }
                return groupedData;
            } else {
                return [];
            }
        }
    },
    methods:{
        setScrollTop(){
			if(this.isFixed){
                this.$parent.scrollTo({
                    scrollTop: this.fixedTop + 1,
                    behavior: 'instant'
                })
            }
        },
        goDetail(url){
            appInteraction.webviewOpenUrl(this.cmsIsDomain(url));
        },
        cmsIsDomain(url){
            if(!(/^http|https/.test(url))){
                url = process.env.VUE_APP_CMS_URL + url;
            }
            return url;
        },
        openSelectGroup(){
            this.$refs.groupPopup.open()
            this.groupShow = true;
        },
        closeSelectGroup(){
            this.$refs.groupPopup.close();
            this.groupShow = false;
        },
        selectGroup(obj) {
            if (this.group.id != obj.Id) {
                this.group.id = obj.Id;
                this.group.name = obj.Name;
                if(this.isSynthesis){
                    this.group.type = obj.TeamType;
                    this.group.scoreType = obj.ScoreType;
                    this.getEventsRankingList(false);
                }else{
                    this.isGetAll = false;
                    this.GetRankingList(1);
                }
                this.setScrollTop();
            }
            this.closeSelectGroup();
        },
        getNewsList(){
            if (this.channelUrl) {
                this.$api.json(this.channelUrl).then(data=>{
                    this.channelList = data.contents || [];
                    this.channelListLoadMore = this.channelList.length > 0 ? "" : "无数据";
                }).catch(()=>{
                    this.channelListLoadMore = "数据加载失败";
                })
            } else {
                this.channelListLoadMore = "无数据";
            }
        },
        getEventsNewsList(){
            this.channelList = [];
            this.channelListLoadMore = '加载中...';
            if(this.events){
                let {
                    MatchResultChanId
                } = this.events;
                if(MatchResultChanId){
                    this.$api.json(MatchResultChanId).then(data => {
                        this.channelList = data.contents || [];
                        this.channelListLoadMore = this.channelList.length > 0 ? "" : "无数据";
                    }).catch(()=>{
                         this.channelListLoadMore = "数据加载失败";
                    });
                }else{
                    this.channelListLoadMore = "无数据";
                }
            }
        },
        GetRankingList(type, lastId){
            if(type == 1){
                this.lastId = 0;
                lastId = 0;
                this.groupRankingList = [];
                this.group.scoreType = 0;
            }
            this.isGetData = false;
            this.loadMore = '加载中...';
            this.$api.GetSubLeagueGroupRankingList({
                Continuation: {
                    LastId: lastId,
                    MaxCount: 20
                },
                SubLeagueId: this.subLeagueId,
                LeagueGroupId: this.group.id
            }).then(data=>{
                this.isGetData = true;
                this.loadMore = '';
                if(data.Code == 0){
                    if(this.groupList.length == 0 && data.LeagueGroupList && data.LeagueGroupList.length > 0){
						this.groupList = data.LeagueGroupList;
                        this.group.name = data.LeagueGroupList[0].Name;
                        this.group.id = data.LeagueGroupList[0].Id;
                    }
                    if(type == 1){
                        this.group.type = data.CurrentLeagueGroup.JoinWay;
                    }
                    if(!data.ContinuedList || data.ContinuedList.length == 0){
                        if(lastId == 0){
                            this.loadMore = '无数据';
                        }
                        if(this.channelList.length == 0){
                            this.getNewsList();
                        }
                        this.isGetAll = true;
                        this.isGetData = false;
                    }else{
                        if(lastId == 0){
                            this.group.scoreType = data.ContinuedList[0].Prize ? 1 : 0;
                            this.groupRankingList = data.ContinuedList;
                        }else{
                            this.groupRankingList.push.apply(this.groupRankingList, data.ContinuedList);
                        }
                        if(data.ContinuedList.length < 20){
                            this.isGetAll = true;
                            if(this.channelList.length == 0){
                                this.getNewsList();
                            }
                        }
                        this.lastId = data.ContinuedList[data.ContinuedList.length-1].TeamRankingId;
                    }
                }
            }).catch(()=>{
                this.isGetData = true;
                this.loadMore = '';
            })
        },
        getEventsRankingList(isInit){
            if(this.events){
                let {
                    EventsName,
                    Groups,
                    IsHaveScore
                } = this.events;
                if(isInit){
                    let groupList = Groups.map((item, index)=>({...item, Id: index + 1, Name: item.GroupName}))
                    this.groupList = groupList;
                    this.group = {
                        name: groupList[0].Name,
                        id: groupList[0].Id,
                        type: groupList[0].TeamType,
                        scoreType: groupList[0].ScoreType
                    };
                    this.isEventsScored = IsHaveScore;
                }
                this.groupRankingList = [];
                this.loadMore = '加载中...';
                this.$api.json(`https://file.dazhongyundong.com/zhish/${this.subLeagueId}/${EventsName}_${this.group.name}.json`).then(list => {
                    this.loadMore = '';
                    if(list && list.length > 0){
                        this.groupRankingList = list;
                    }else{
                        this.loadMore = '无数据';
                    }
                }).catch(()=>{
                    this.loadMore = '数据加载失败';
                });
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.GemaResult_container{
    .column_list{
        width: 100%;
        height: auto;
        padding: 40px 0 56px 40px;
        box-sizing: border-box;
        ul li{
            width: 100%;
            height: auto;
            padding-right: 40px;
            box-sizing: border-box;
            border-bottom: 1px #F0F0F0 solid;
            margin-bottom: 33px;
            &:last-of-type{
                border-bottom: none;
                margin-bottom: 0;
            }
            .release_info{
                display: flex;
                align-items: center;
                justify-content: space-between;
                img{
                    width: 32px;
                    height: 32px;
                    margin-right: 14px;
                }
                div{
                    font-size: 24px;
                    color: #41454D;
                    font-weight: 400;
                    &.release_time{
                        color: #999999;
                    }
                }
            }
            .communique_content{
                padding: 32px 0 34px;
                display: flex;
                justify-content: space-between;
                .communique_title{
                    width: 420px;
                    font-size: 32px;
                    color: #1B1C1E;
                    font-weight: 500;
                    line-height: 44px;
                }
                img{
                    width: 128px;
                    height: 128px;
                }
            }
        }
    }
    .ranking_title {
        width: 100%;
        height: 156px;
        background: #FFFFFF;
        position: sticky;
        left: 0;
        z-index: 2;
        &.shadow{
            @include tab-shadow;
        }
        .group_name{
            width: 100%;
            height: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            >div{
                width: 100%;
                height: auto;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            span{
                max-width: 80%;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 30px;
                color: #1B1C1E;
                line-height: 40px;
                white-space: pre-wrap;
                text-align: center;
            }
            img{
                width: 32px;
                height: 32px;
                margin-left: 8px;
            }
        }
    }
    .ranking_title_content {
        width: 100%;
        height: 76px;
        >ul {
            width: 100%;
            height: 76px;
            padding: 0 40px;
            box-sizing: border-box;
            display: flex;
            align-items: center;

            >li {
                font-size: 28px;
                color: #B9B9B9;
                font-weight: 500;
            }
        }
    }
    .ranking_title_content,
    .ranking_content{
        &.type_3{
            .affiliated_unit{
                width: 400px;
            }
        }
        .info{
            flex: 1;
        }
        .affiliated_unit{
            width: 500px;
            padding-left: 16px;
            box-sizing: border-box;
        }
    }
    .ranking_content{
        width: 100%;
        height: auto;
        ul{
            width: 100%;
            height: auto;
            li{
                width: 100%;
                height: auto;
                padding: 20px 40px;
                box-sizing: border-box;
                background: #FAFBFA;
                font-size: 28px;
                font-weight: 400;
                line-height: 40px;
                display: flex;
                &.prize_title{
                    height: 72px;
                    padding: 0;
					position: sticky;
                    left: 0;
                    .prize_title_fixed{
                        width: 100%;
                        @include line-height(72px);
                        background: #FFF6DD;
						padding-left: 40px;
                        box-sizing: border-box;
                        font-size: 28px;
                        color: #F79611;
                        font-weight: 500;
                        position: relative;
                    }
                }
                &:nth-of-type(2n){
                    background: #FFFFFF;
                }
                .info{
                    display: flex;
                    &.prize span{
                        width: 100%;
                    }
                    i{
                        width: 56px;
                        height: 100%;
                        color: #F79611;
                        font-weight: 600;
                        vertical-align: top;
                    }
                    span{
                        width: calc(100% - 56px);
                        color: #1B1C1E;
                    }
                }
                .affiliated_unit{
                    color: #666666;
                }
            }
        }
    }
}
.select_group{
    width: 100%;
    padding-bottom: 40px;
    box-sizing: border-box;
    .group_list{
        width: 100%;
        height: 614px;
        overflow-y: auto;
        ul{
            width: 100%;
            height: auto;
            li{
                width: 100%;
                height: 104px;
                padding: 0 40px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: center;
                span{
                    font-weight: 400;
                    font-size: 28px;
                    color: #1B1C1E;
                    line-height: 40px;
                    text-align: center;
                }
                &.active span{
                    font-weight: 500;
                    font-size: 28px;
                    color: #7AD21A;
                }
            }
        }
    }
    .button{
        width: 520px;
        height: 108px;
        background: #1B1C1E;
        border-radius: 54px;
        margin: 0 auto;
        
        font-weight: 500;
        font-size: 32px;
        color: #FFFFFF;
        line-height: 108px;
        text-align: center;
    }
    
}
</style>